import { render, staticRenderFns } from "./GroupModal.vue?vue&type=template&id=925de722&"
import script from "./GroupModal.vue?vue&type=script&lang=js&"
export * from "./GroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports